var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{staticClass:"popup-select-893",attrs:{"title":"공정활동분류표","active":_vm.showPopup},on:{"update:active":function($event){_vm.showPopup=$event}}},[_c('page893',{ref:"page893",attrs:{"mode":"popup"},on:{"close":function($event){_vm.showPopup = false;},"select":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }